import { ChatMessageFormat } from "@sap/cpaas-commlib-lib";

export interface IChatQueue {
	id: string;
	address: string;
	channel: number;
	scheduleState: number;
	timeZone: string;
	dayOfWeekScheduleId: number;
	names: Array<{ name: string, language: string }>;
	calendarSchedules: any[];
	dayOfWeekSchedule: any[];
}


export interface IChatMessage {
	entity: Entity;
	alias?: string;
	timestamp?: string;
	level?: Level;
	content?: any;
	format?: ChatMessageFormat;
	time?: string;
	sender?: number;
	guid: string;
	contact?: number;
	hidden?: boolean;
}

export type Template = { keywords?: { [id: string]: string[] }, name: string, language: string, body: string, id: string };
export type StaticTemplate = { body: string, id: string };

export type LaunchPadConfig = { headers: { [lang: string]: string }, channels: Array<LaunchPadItem>, position:"grid"|"vertical"|"horizontal", mirrorUi: boolean }
export type LaunchPadItem = { title: string, headers: { [lang: string]: string }, icon: string | { base64:string, name:string }, type: SubChannel, address: string, properAddress: string, qr?: {base64:string, name:string}, queueId?: string, url?: string, altUrl?: string, linkText?: string, key?: string }

export enum Entity {
	visitor, agent, system, notification, unknown,
}

export enum Level {
	Success = "success",
	Primary = "primary",
	Secondary = "secondary",
	Info = "info",
	Warning = "warning",
	Danger = "danger",
	Link = "link",
	Light = "light",
	Dark = "dark",
}

export enum Color {
	Success = "text-success",
	Primary = "text-primary",
	Secondary = "text-secondary",
	Info = "text-info",
	Warning = "text-warning",
	Danger = "text-danger",
	White = "text-white",
	Light = "text-light",
	Dark = "text-dark",
}

export enum BgColor {
	Success = "bg-success",
	Primary = "bg-primary",
	Secondary = "bg-secondary",
	Info = "bg-info",
	Warning = "bg-warning",
	Danger = "bg-danger",
	Light = "bg-light",
	Dark = "bg-dark",
	White = "bg-white",
}

export enum SubChannel {
	whatsapp = "whatsapp",
	telegram = "telegram",
	messenger = "messenger",
	viber = "viber", // Chat scripts created prior to 24Q1 contain just "viber" which defaults to Viber Chatbot.
	viberChatbot = "viber-chatbot",
	viberBusinessMessages = "viber-business-messages",
	video = "video",
	webchat = "webchat",
	callback = "callback",
	phone = "phone",
	email = "email",
	sms = "sms",
	custom = "custom",
}

export enum SystemMessageChatState {
	joined = "JOINED",
	left = "LEFT",
	transferred = "CHAT_TRANSFERRED",
	other = "OTHER_SKIPPABLE"
}